import {useState} from "react";
import {useSelector} from "react-redux";
import {currentUser} from "../../../features/user/userSlice";
import styled from "styled-components";
import {Button, Form, Input, Modal} from "antd";
import {useMutation, useQueryClient} from "react-query";
import {applyTeam} from "../../../api/Team";
import {useParams} from "react-router-dom";

const CustomInputTextarea = styled(Input.TextArea)`
    height: 120px !important;
    line-height: 30px !important;
    border-radius:4px !important;
    &:hover{
        border-color: #6ee6c6 !important;
    };
    &:focus-within{
        border-color: #6ee6c6 !important;
    }
`
const ApplyButton = styled(Button)`
    font-family: HelveticaNeueBold;
    height: 40px;
    border-radius: 20px;
    border-color: #6ee6c6;
    color:#6ee6c6;
    &:hover,
    &:focus-within {
        border-color: #6ee6c6;
        background-color: #6ee6c6;
        color:#000;
    };
`

const CustomModal = styled(Modal)`
  .ant-btn-primary {
    background-color: #6ee6c6;
    color: #000;
    border-color: #6ee6c6;
  }
  .ant-btn-default {
    &:hover {
      border-color: #6ee6c6;
      color: #6ee6c6;
    }
  }
`

export const Apply = ({userMemberStatus, team}) => {
    const { title } = useParams();
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [comment, setComment] = useState('')
    const user = useSelector(currentUser);
    const queryClient = useQueryClient()
    const {mutateAsync, isLoading} = useMutation('team_apply', ({id, comment}) => {
        return applyTeam(id, comment)
    })

    if (!user?.token) return null

    if (userMemberStatus === 1 && team.member_status === 1) return (
        <ApplyButton disabled>Joined</ApplyButton>
    )

    if (user.user.type !== 0 || userMemberStatus === 1 || (userMemberStatus === 0 && team.member_status !== 0)) return null

    if (userMemberStatus === 0 && team.member_status === 0) return (
        <ApplyButton disabled>Pending</ApplyButton>
    )

    const handleCancel = () => {
        setComment('')
        setIsModalOpen(false)
    }

    const handleOk = async () => {
        await mutateAsync({id: team.id, comment})
        if (title) {
            await queryClient.invalidateQueries(['team-detail', title])

        } else {
            await queryClient.invalidateQueries('teams')
        }
        await queryClient.invalidateQueries('userinfo')
        handleCancel()
    }

    return (
        <>
            <ApplyButton onClick={() => setIsModalOpen(true)}>Apply</ApplyButton>
            <CustomModal confirmLoading={isLoading} okText='Apply' title="Apply Comment" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Form>
                    <Form.Item label=''>
                        <CustomInputTextarea placeholder='(optional)' value={comment} onChange={e => setComment(e.target.value)} />
                    </Form.Item>
                </Form>
            </CustomModal>
        </>
    )
}
